<template>
<div>
  <div v-if="loading">
    <div class="animated loader"></div>
  </div>
  <div class="container pt-2">
    <div class="row">
      <div class="col-12">
        <p class="logo text-center">
          <a v-bind:href="'https://uproc.io'" target="_blank">
            <svg width="56" height="66" viewBox="0 0 56 66" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M33.0627 7.05834C33.0627 17.0093 27.3645 22.5161 17.755 22.5161C16.0433 22.5161 14.4558 22.3414 13.0024 21.998C15.4055 27.8663 21.172 32 27.9036 32C36.7934 32 44 24.791 44 15.8982C44 8.81039 39.422 2.79222 33.0627 0.641137V7.05834ZM12 13.399C13.293 15.0897 15.2718 15.8499 17.8033 15.8499C22.5839 15.8499 25.3364 13.1931 25.3364 6.7685V0C18.4799 1.09935 13.0699 6.53048 12 13.399Z"
                fill="#0C6BFF" />
              <path
                d="M8.54966 46.316V51.104C8.54966 52.886 7.61366 53.714 6.31766 53.714C5.07566 53.714 4.35566 52.994 4.35566 51.374V46.316H1.54766V51.788C1.54766 54.776 3.25766 56.144 5.68766 56.144C6.87566 56.144 7.95566 55.694 8.69366 54.848V56H11.3577V46.316H8.54966ZM19.6111 43.4H14.1571V56H17.0731V52.526H19.6111C22.9771 52.526 25.0831 50.78 25.0831 47.972C25.0831 45.146 22.9771 43.4 19.6111 43.4ZM19.4491 50.15H17.0731V45.776H19.4491C21.2311 45.776 22.1311 46.586 22.1311 47.972C22.1311 49.34 21.2311 50.15 19.4491 50.15ZM29.6489 47.594V46.316H26.9669V56H29.7749V51.428C29.7749 49.574 30.8009 48.728 32.3489 48.728C32.5649 48.728 32.7449 48.746 32.9789 48.764V46.172C31.4849 46.172 30.3329 46.658 29.6489 47.594ZM39.1686 56.144C42.2466 56.144 44.4786 54.074 44.4786 51.158C44.4786 48.242 42.2466 46.172 39.1686 46.172C36.0906 46.172 33.8406 48.242 33.8406 51.158C33.8406 54.074 36.0906 56.144 39.1686 56.144ZM39.1686 53.84C37.7646 53.84 36.6846 52.832 36.6846 51.158C36.6846 49.484 37.7646 48.476 39.1686 48.476C40.5726 48.476 41.6346 49.484 41.6346 51.158C41.6346 52.832 40.5726 53.84 39.1686 53.84ZM51.0356 56.144C53.0696 56.144 54.6716 55.244 55.3736 53.696L53.1956 52.508C52.6736 53.444 51.8996 53.84 51.0176 53.84C49.5956 53.84 48.4796 52.85 48.4796 51.158C48.4796 49.466 49.5956 48.476 51.0176 48.476C51.8996 48.476 52.6736 48.89 53.1956 49.808L55.3736 48.638C54.6716 47.054 53.0696 46.172 51.0356 46.172C47.8856 46.172 45.6356 48.242 45.6356 51.158C45.6356 54.074 47.8856 56.144 51.0356 56.144Z"
                fill="#0C6BFF" />
            </svg>
          </a>
        </p>
        <h3 class="welcome text-center">Welcome back to uProc!</h3>
        <div class="row">
          <div class="col-12 d-flex flex-row justify-content-center">
            <div>
              <br>
              <div class="alert alert-success" v-if="result !== null && result.result" v-html="$t('signup-confirm-ok')"></div>
              <div class="alert alert-warning" v-if="result !== null  && !result.result" v-html="$t('signup-confirm-ko')"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: 'Confirm',
  components: {
    Footer
  },
  data() {
    return {
      loading: false,
      result: null
    }
  },
  mounted: function() {
    this.confirm();
  },
  methods: {
    confirm: function() {
      this.loading = true;
      var url = '/api/v2/confirm/signup/' + this.$route.params.id;
      this.$http.get(url).then((results) => {
        this.result = results.data;
        console.log(this.result)
        this.loading = false;
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../assets/css/login_signup.css';
</style>
